<div data-test="SnackBar" matSnackBarLabel>
  <div *ngIf="data.title" class="mat-subtitle-1">{{ data.title | translate }}</div>
  <ng-container *ngIf="data.validationMessages">
    <ul>
      <ng-container *ngFor="let item of data.validationMessages"
        ><li>{{ item.Text }}</li></ng-container
      >
    </ul>
  </ng-container>
  <ng-container
    *ngIf="
      (data.commonMessage && !data.adminMessage) ||
      (data.commonMessage && data.adminMessage && (isDeveloper | async) === true && (isAdmin | async) === true)
    "
  >
    <div>{{ data.commonMessage | translate }}</div>
  </ng-container>
  <ng-container *ngIf="data.message">{{ data.message | translate }}</ng-container>
  <ng-container *ngIf="data.adminMessage && ((isDeveloper | async) || (isAdmin | async))">
    <div>{{ data.adminMessage }}</div>
  </ng-container>
  <ng-container>
    <div *ngIf="data.adminLink">{{ 'UI.Common.Action.CheckErrorInAdminApp' | translate }}</div>
    <span matSnackBarActions>
      <a
        *ngIf="data.adminLink"
        mat-button
        class="snackbar-button"
        color="primary"
        [href]="baseUrl + '/Admin/logs'"
        target="_blank"
        matSnackBarAction
        >{{ 'UI.Common.Action.GoToAdminApp' | translate }}</a
      >

      <a *ngIf="data.closeButtonLink" [routerLink]="data.closeButtonLink">
        <button mat-button class="snackbar-button" color="accent" matSnackBarAction (click)="closeSnackbar()">
          {{ data.closeButtonText | translate }}
        </button>
      </a>

      <button *ngIf="!data.closeButtonLink" mat-button class="snackbar-button" color="accent" matSnackBarAction (click)="closeSnackbar()">
        {{ 'UI.Common.Action.Close' | translate }}
      </button>
    </span>
  </ng-container>
</div>
